var render = function () {
  var _vm$value$fleet, _vm$value$fleet2, _vm$value$vehicle;

  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_vm.value.isVehicleLoading || _vm.value.isFleetLoading || (_vm$value$fleet = _vm.value.fleet) !== null && _vm$value$fleet !== void 0 && _vm$value$fleet.isLoadingCompany || (_vm$value$fleet2 = _vm.value.fleet) !== null && _vm$value$fleet2 !== void 0 && _vm$value$fleet2.isLoadingContracts || (_vm$value$vehicle = _vm.value.vehicle) !== null && _vm$value$vehicle !== void 0 && _vm$value$vehicle.loading ? _c('v-skeleton-loader', {
    staticClass: "mb-2",
    attrs: {
      "type": "image",
      "height": "124"
    }
  }) : _c('v-sheet', {
    staticClass: "py-2",
    attrs: {
      "color": _vm.$vuetify.theme.dark ? 'grey darken-3' : 'grey lighten-4',
      "rounded": ""
    }
  }, [_vm.isApprovalLimits ? _c('v-card-subtitle', [_c('v-chip', {
    attrs: {
      "color": "red",
      "small": "",
      "dark": ""
    }
  }, [_vm._v(" " + _vm._s(_vm.$t("components.PartnerReportDetail.rental.RentalApprovalLimitsSheet.attention")) + " "), _c('v-icon', {
    attrs: {
      "dark": "",
      "small": "",
      "right": ""
    }
  }, [_vm._v(" mdi-information-slab-circle-outline ")])], 1)], 1) : _vm._e(), _c('m-expansion', {
    staticClass: "mx-4 mb-2 mt-n4",
    scopedSlots: _vm._u([{
      key: "label",
      fn: function fn() {
        return [_vm._v(" " + _vm._s(_vm.$t("contract.contract")) + " ")];
      },
      proxy: true
    }]),
    model: {
      value: _vm.showCustomerContract,
      callback: function callback($$v) {
        _vm.showCustomerContract = $$v;
      },
      expression: "showCustomerContract"
    }
  }, [_vm.activeCustomerContract ? _c('m-text-field', {
    attrs: {
      "hide-details": "",
      "readonly": "",
      "label": _vm.$t('objects.contract.customer.comprehensiveRentalCarDefault'),
      "hint": _vm.$t('objects.contract.customer.comprehensiveRentalCarDefaultHint'),
      "value": _vm.activeCustomerContract.comprehensiveRentalCarDefault
    }
  }) : _vm._e(), _vm.activeCustomerContract ? _c('m-text-field', {
    attrs: {
      "hide-details": "",
      "readonly": "",
      "label": _vm.$t('objects.contract.customer.rentalCarVIPDefault'),
      "hint": _vm.$t('objects.contract.customer.rentalCarVIPDefaultHint'),
      "value": _vm.activeCustomerContract.rentalCarVIPDefault
    }
  }) : _vm._e(), _vm.activeCustomerContract ? _c('m-text-field', {
    attrs: {
      "hide-details": "",
      "readonly": "",
      "label": _vm.$t('objects.contract.customer.rentalCarThirdPartyDamageDefault'),
      "hint": _vm.$t('objects.contract.customer.rentalCarThirdPartyDamageDefaultHint'),
      "value": _vm.activeCustomerContract.rentalCarThirdPartyDamageDefault
    }
  }) : _c('m-no-content')], 1), _c('m-expansion', {
    staticClass: "mx-4 mb-2 mt-n4",
    scopedSlots: _vm._u([{
      key: "label",
      fn: function fn() {
        return [_vm._v(" " + _vm._s(_vm.$t("components.fleet.FleetVehicleDetailContractInputs.hasRoadsideAssistance")) + " ")];
      },
      proxy: true
    }]),
    model: {
      value: _vm.showInsuranceContract,
      callback: function callback($$v) {
        _vm.showInsuranceContract = $$v;
      },
      expression: "showInsuranceContract"
    }
  }, [_vm.activeInsuranceContract ? _c('m-text-field', {
    attrs: {
      "hide-details": !_vm.isMaxDaysNotCovered,
      "readonly": "",
      "label": _vm.$t('components.fleet.FleetVehicleDetailContractInputs.rentalCarMaxDays'),
      "value": _vm.activeInsuranceContract.rentalCarMaxDays,
      "error": _vm.isMaxDaysNotCovered,
      "error-messages": _vm.isMaxDaysNotCovered ? [_vm.$t('components.PartnerReportDetail.rental.RentalApprovalLimitsSheet.isMaxDaysNotCovered')] : []
    }
  }) : _vm._e(), _vm.activeInsuranceContract ? _c('m-text-field', {
    attrs: {
      "readonly": "",
      "label": _vm.$t('components.fleet.FleetVehicleDetailContractInputs.rentalCarDailyRate'),
      "value": _vm.activeInsuranceContract.rentalCarDailyRateReadable,
      "error": _vm.isDailyRateNotCovered,
      "error-messages": _vm.isDailyRateNotCovered ? [_vm.$t('components.PartnerReportDetail.rental.RentalApprovalLimitsSheet.isDailyRateNotCovered')] : []
    }
  }) : _c('m-no-content')], 1), _c('v-card-subtitle', [_vm._v(" " + _vm._s(_vm.$t("components.PartnerReportDetail.rental.RentalApprovalLimitsSheet.validity")) + " " + _vm._s(_vm._f("simpleDoubleDigitDate")(_vm.value.accidentDate)) + " ")])], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }